import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import { Link } from 'react-router-dom'; // Import Link
import { BreadcrumbItem as BreadcrumbItemType } from '../../context/BreadcrumbContext';
import { BreadcrumbContainer, BreadcrumbItem as StyledBreadcrumbItem, FolderIconContainer } from './styles';
import FolderIcon from '../../assets/main/home-icon.svg';
import DashboardIcon from '../../assets/sidebar/dashboard-icon.svg';
import ManagementIcon from '../../assets/sidebar/management-icon.svg';
import SettingsIcon from '../../assets/sidebar/settings.svg';

interface BreadcrumbProps {
  path: BreadcrumbItemType[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ path }) => {
  if (!path || path.length === 0) {
    return null;
  }

  const getIconForBreadcrumb = (title: string) => {
    switch (title) {
      case 'Dashboard':
        return DashboardIcon;
      case 'Management':
        return ManagementIcon;
      case 'Settings':
        return SettingsIcon;
      default:
        return DashboardIcon; // Default icon if no specific match
    }
  };

  const firstBreadcrumbIcon = path.length > 0 ? getIconForBreadcrumb(path[0].title) : FolderIcon;

  return (
    <BreadcrumbContainer>
      <FolderIconContainer>
        <img src={firstBreadcrumbIcon} alt={path[0].title} style={{ height: '18px', width: '18px' }} />
      </FolderIconContainer>

      <MuiBreadcrumbs
        separator=">"
        aria-label="breadcrumb"
        sx={{ padding: 0, margin: 0 }}
      >
        {path.map((item, index) => (
          <StyledBreadcrumbItem
            key={item.title}
            variant="body1"
            component={index < path.length - 1 ? Link : 'div'} // Use Link for clickable items
            {...(index < path.length - 1 && { to: item.path })} // Conditionally apply 'to' prop
            sx={{
              textDecoration: index < path.length - 1 ? 'none' : 'none',
              cursor: index < path.length - 1 ? 'pointer' : 'default',
              '&:hover': {
                textDecoration: index < path.length - 1 ? 'underline' : 'none',
              }
            }}
          >
            {item.title}
          </StyledBreadcrumbItem>
        ))}
      </MuiBreadcrumbs>
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;